const aws = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:e981be43-6fe7-44f1-a226-ff59962d1998',
  userPoolId: 'eu-west-1_ZPGnhlKyx',
  userPoolClientId: '36cft4ttrhbp5a2brkkshi7cg9',
  productionManagementAppsyncEndpoint: 'https://6a66oh3ufvbylg4q5ycu6xpueu.appsync-api.eu-west-1.amazonaws.com/graphql',
  userManagementAppsyncEndpoint: 'https://fimfsilirvdpri4wqnn3dpzvwi.appsync-api.eu-west-1.amazonaws.com/graphql',
};
export default aws;
